import { useEffect, useState } from "react";
import { createConnectivityMonitor } from "../offline/connectivity";
import { getLatestSyncAt } from "../offline/offlineRepository";
import { CACHEABLE_TABLES } from "../offline/schema";

export function useOfflineStatus() {
  const [status, setStatus] = useState({
    browserOnline: true,
    supabaseReachable: true,
    online: true,
    checkedAt: null,
    lastSyncAt: null,
  });

  useEffect(() => {
    let active = true;

    const refreshLastSync = async () => {
      const lastSyncAt = await getLatestSyncAt(Array.from(CACHEABLE_TABLES));
      if (!active) return;
      setStatus((prev) => ({ ...prev, lastSyncAt }));
    };

    const monitor = createConnectivityMonitor((next) => {
      if (!active) return;
      setStatus((prev) => ({ ...prev, ...next }));
      refreshLastSync();
    });

    let stop = () => {};
    monitor.start().then((cleanup) => {
      stop = cleanup || (() => {});
    });

    // Nota: NO hacemos un probe suelto acá. El monitor ya hace el primer chequeo
    // al iniciar y aplica el debounce (FAILURE_THRESHOLD). Un probe suelto sin
    // debounce podía marcar "sin conexión" con un único fallo en el arranque.
    refreshLastSync();

    return () => {
      active = false;
      stop();
    };
  }, []);

  return status;
}

